export * from "@agrigate/shared-web-ui/lib/utils/posthog";

import {
    getPostHog,
    getPostHogPrefix,
    setDefaultProp,
} from "@agrigate/shared-web-ui/lib/utils/posthog";
import posthog from "posthog-js";

let isPostHogInitialized = false;

setDefaultProp("app", "AP");

getPostHog.override(() => {
    return () => {
        if (!isPostHogInitialized && POSTHOG_KEY && POSTHOG_HOST) {
            posthog.init(POSTHOG_KEY, {
                api_host: POSTHOG_HOST,
            });
            isPostHogInitialized = true;
        }

        return posthog;
    };
});

getPostHogPrefix.override(
    () => () => (DEPLOY_ENV ?? "development").charAt(0).toUpperCase(),
);
